module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "place-tab"
  }, [_c('yandex-map', {
    staticClass: "map",
    attrs: {
      "zoom": "15",
      "coords": _vm.cashedCoords,
      "zoom": _vm.currentZoom
    },
    on: {
      "map-was-initialized": _vm.onMapInitialized
    }
  }, _vm._l((_vm.geo), function(item, index) {
    return _c('ymap-marker', {
      key: index,
      attrs: {
        "marker-type": "placemark",
        "marker-id": ((item.lng) + "-" + (item.lat)),
        "hint-content": item.location,
        "coords": [parseFloat(item.lat), parseFloat(item.lng)],
        "balloon": {
          header: _vm.title,
          body: item.location,
          footer: ''
        },
        "icon": {
          color: 'blue'
        }
      }
    })
  }), 1), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "place-container"
  }, [_c('p', [_vm._v("Актуальные программы обучения, интересные занятия, опытные преподаватели и новые профессиональные возможности отрывает для каждого цифровая платформа ЦОПП")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47d7efcf","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/place/Place.vue
// module id = fc10d43db1e0c55f1ade
// module chunks = 5